import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getReports, saveReport } from '../services/storageService';
// Import ReportStatus from the constants file
import { ReportStatus } from '../components/constants';
import { CheckCircle, Lock } from 'lucide-react';

const PaymentPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [report, setReport] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const all = getReports();
    const found = all.find(d => d.id === id);
    if (found) {
        setReport(found);
    } else {
        navigate('/');
    }
  }, [id, navigate]);

  const handleRecordSettlement = () => {
    if (!report) return;
    setProcessing(true);

    // Simulate recording
    setTimeout(() => {
        const updated = { ...report, status: ReportStatus.PUBLISHED_SETTLED };
        saveReport(updated);
        setReport(updated);
        setProcessing(false);
        setSuccess(true);
    }, 1500);
  };

  if (!report) return <div className="text-white p-8">Loading...</div>;

  if (success) {
      return (
          <div className="max-w-md mx-auto mt-20 p-8 bg-slate-800 rounded-2xl text-center border border-emerald-500/50">
              <div className="w-20 h-20 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="h-10 w-10 text-emerald-500" />
              </div>
              <h2 className="text-2xl font-bold text-white mb-2">Settlement Recorded</h2>
              <p className="text-slate-400 mb-6">This report has been publicly updated to 'Settled'.</p>
              <button onClick={() => navigate('/dashboard')} className="text-emerald-400 hover:text-emerald-300 font-medium">Return to Dashboard</button>
          </div>
      )
  }

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
        <div className="bg-slate-800 rounded-2xl overflow-hidden shadow-2xl border border-slate-700">
            <div className="bg-slate-900 p-6 border-b border-slate-700 flex justify-between items-center">
                <h1 className="text-xl font-bold text-white">Record Settlement</h1>
                <div className="flex items-center gap-2 text-slate-400 text-sm">
                    <Lock size={14} />
                    Secure Record
                </div>
            </div>
            
            <div className="p-8">
                <p className="text-slate-400 mb-8 text-center">
                    You are marking this debt as fully paid. This will update the public record permanently.
                </p>

                <div className="space-y-4 bg-slate-900/50 p-6 rounded-xl border border-slate-700/50 mb-8">
                    <div className="flex justify-between text-sm">
                        <span className="text-slate-400">Borrower</span>
                        <span className="text-white font-medium">{report.borrowerName}</span>
                    </div>
                    <div className="flex justify-between text-sm">
                        <span className="text-slate-400">Total Amount</span>
                        <span className="text-emerald-400 font-bold font-mono">${report.amount.toLocaleString()}</span>
                    </div>
                </div>

                <button 
                    onClick={handleRecordSettlement}
                    disabled={processing}
                    className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-4 rounded-lg shadow-lg shadow-emerald-900/20 transition-all flex justify-center items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {processing ? (
                        <>Updating Records...</>
                    ) : (
                        <>Confirm Debt Settled</>
                    )}
                </button>
            </div>
        </div>
    </div>
  );
};

export default PaymentPage;